import React from "react";
import {
  ListItem,
  ListItemText,
  Typography,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material/index";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1
  },
  menu: {
    color: theme.palette.text.primary,
    padding: theme.spacing(4, 2, 2, 2),
    minWidth: 210
  },
  option: {
    paddingLeft: theme.spacing(2)
  },
  icon: {
    padding: 0
  }
}));

const TopNavProfileDropdown = ({ profileDropdownOptions, onOptionClick }) => {
  const classes = useStyles();
  const [dropdownAnchor, setDropdownAnchor] = React.useState(null);
  const open = Boolean(dropdownAnchor);

  const handleClose = () => {
    setDropdownAnchor(null);
  };

  function handleExpand(event) {
    setDropdownAnchor(dropdownAnchor ? null : event.currentTarget);
  }

  function handleOptionClick(option) {
    setDropdownAnchor(null);
    onOptionClick(option);
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label="Expand Messages"
        color={open ? "primary" : "inherit"}
        onClick={handleExpand}
      >
        {!open && <ArrowDropDown />}
        {open && <ArrowDropUp />}
      </IconButton>
      <Menu
        anchorEl={dropdownAnchor}
        transformOrigin={{ vertical: -22, horizontal: "left" }}
        open={open}
        onClose={handleClose}
      >
        {profileDropdownOptions.map((option, index) => (
          <MenuItem onClick={() => handleOptionClick(option)} key={index}>
            <ListItem key={index}>
              <ListItemIcon color="inherit" className={classes.icon}>
                {option.icon}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    color="textPrimary"
                    variant="body2"
                    className={classes.option}
                  >
                    {option.title}
                  </Typography>
                }
              />
            </ListItem>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default TopNavProfileDropdown;
TopNavProfileDropdown.propTypes = {
  profileDropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      title: PropTypes.string,
      path: PropTypes.string
    })
  )
};
